export default __webpack_public_path__ + "static/media/uploader-animas-1.7d94b046.png";